import React, { FC } from 'react'

import { FileFieldProps } from '@/types'
import { FileInput } from '@/molecules/file-input'
import { BaseField } from '@/molecules/base-field'

export const FileField: FC<FileFieldProps> = ({
  error,
  label,
  defaultCaption,
  name,
  value,
  logoUrl,
  multiple,
  onChange,
  onBlur,
  mainDefaultText = 'Archivo',
  buttonText = 'Examinar',
  containerProps = {},
  labelProps = {},
  captionProps = {},
  inputProps = {},
}) => {
  return (
    <BaseField
      label={label}
      caption={defaultCaption}
      error={error}
      containerProps={containerProps}
      labelProps={labelProps}
      captionProps={captionProps}
    >
      <FileInput
        mainDefaultText={mainDefaultText}
        buttonText={buttonText}
        logoUrl={logoUrl}
        name={name}
        value={value}
        multiple={multiple}
        onChange={onChange}
        onBlur={onBlur}
        {...inputProps}
      />
    </BaseField>
  )
}
